import { Button, HFlow, Modal, ModalBody, ModalFooter, ModalHeader, Text, VFlow } from 'bold-ui'
import { SubmitButton } from 'components/form'
import { ServicosCertificadoEnum } from 'graphql/types.generated'

type ServicosSelecionadosProps = {
  servicosSelecionados?: ReadonlyArray<ServicosCertificadoEnum>
  servicosValidados?: ReadonlyArray<ServicosCertificadoEnum>
  isModalOpen: boolean
  handleModalClose(): void
  handleModalSubmit(): void
  loading: boolean
}

const ordemServicos = [
  ServicosCertificadoEnum.RNDS,
  ServicosCertificadoEnum.CADSUS,
  ServicosCertificadoEnum.PDM,
  ServicosCertificadoEnum.SINAN,
]

function listarServicos(servicos?: ReadonlyArray<ServicosCertificadoEnum>) {
  return ordemServicos.filter((servico) => servicos?.includes(servico)).join(', ') || '-'
}

export function ServicosSelecionadosConfirmacaoModal({
  servicosSelecionados,
  servicosValidados,
  isModalOpen,
  handleModalClose,
  handleModalSubmit,
  loading,
}: ServicosSelecionadosProps) {
  return (
    <Modal open={isModalOpen} onClose={handleModalClose} size='small'>
      <ModalHeader
        title='Serviços selecionados diferentes do certificado'
        icon={{ name: 'exclamationTriangleOutline', fill: 'alert' }}
      />
      <ModalBody>
        <HFlow>
          <VFlow vSpacing={0}>
            <Text>Serviços selecionados: {listarServicos(servicosSelecionados)}</Text>
            <Text>Serviços vinculados no certificado: {listarServicos(servicosValidados)}</Text>
            <Text>Deseja continuar?</Text>
          </VFlow>
        </HFlow>
      </ModalBody>
      <ModalFooter>
        <HFlow justifyContent='flex-end'>
          <Button size='medium' onClick={handleModalClose}>
            Cancelar
          </Button>
          <SubmitButton
            kind='primary'
            skin='default'
            size='medium'
            handleSubmit={handleModalSubmit}
            disabled={loading}
            loading={loading}
          >
            Continuar
          </SubmitButton>
        </HFlow>
      </ModalFooter>
    </Modal>
  )
}
